// extracted by mini-css-extract-plugin
export default {"loading":"MyLocations_loading__5F+oW","done_message":"MyLocations_done_message__FxWHk"};